import React from 'react'
import PropTypes from 'prop-types'

// Models
import Payment from 'models/Payment'

// Components
import Text from 'ui/Text'

export default function ColumnAmount({ row }) {
  return (
    <div>
      <Text color="#000000">{row.netAmount}</Text>
      <Text size={13} color="#606060">
        Gross: {row.grossAmount}
      </Text>
    </div>
  )
}

ColumnAmount.propTypes = {
  row: PropTypes.instanceOf(Payment),
}

ColumnAmount.defaultProps = {
  row: new Payment(),
}
